import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { patchDeleteOrganizationFromProject } from '../services/patchRemoveOrganizationFromProject.service';

const parseStructuredError = (error) => {
  const responseData = error?.response?.data;

  if (!responseData) {
    return { message: error?.message };
  }

  if (typeof responseData === 'object') {
    return responseData;
  }

  try {
    return JSON.parse(responseData);
  } catch {
    return { message: responseData };
  }
};

export const deleteBusinessOrganizationFromProject = createAsyncThunk(
  'organizationCharts/deleteBusinessOrganizationFromProject',
  async (organizationChartItemIdToDelete, { getState, rejectWithValue }) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    try {
      const response = await patchDeleteOrganizationFromProject(
        selectedProjectId,
        organizationChartItemIdToDelete
      );

      return response;
    } catch (error) {
      const structuredError = parseStructuredError(error);

      return rejectWithValue(structuredError);
    }
  }
);
